"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _LoadingSuccessButton = _interopRequireDefault(require("./LoadingSuccessButton"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LoadingButton = /*#__PURE__*/function (_React$Component) {
  _inherits(LoadingButton, _React$Component);

  var _super = _createSuper(LoadingButton);

  function LoadingButton(props) {
    var _this;

    _classCallCheck(this, LoadingButton);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "resetState", function () {
      _this.setState({
        state: null
      });
    });

    _this.state = {
      // eslint-disable-next-line react/destructuring-assignment
      state: _this.props.isLoading ? _constants.LOADING : null
    };
    return _this;
  } // eslint-disable-next-line camelcase


  _createClass(LoadingButton, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(_ref) {
      var isLoading = _ref.isLoading;
      var wasLoading = this.props.isLoading;

      if (wasLoading && !isLoading) {
        this.setState({
          state: _constants.SUCCESS
        });
      } else if (!wasLoading && isLoading) {
        this.setState({
          state: _constants.LOADING
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _ref2) {
      var stateWas = _ref2.state;
      var stateIs = this.state.state,
          successTimeout = this.props.successTimeout;

      if (stateWas === _constants.LOADING && stateIs === _constants.SUCCESS) {
        this.timeout = setTimeout(this.resetState, successTimeout);
      } else if (stateWas === _constants.SUCCESS && stateIs === _constants.LOADING) {
        clearTimeout(this.timeout);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var state = this.state.state,
          _this$props = this.props,
          disabled = _this$props.disabled,
          isLoading = _this$props.isLoading,
          successTimeout = _this$props.successTimeout,
          props = _objectWithoutProperties(_this$props, ["disabled", "isLoading", "successTimeout"]);

      return /*#__PURE__*/_react["default"].createElement(_LoadingSuccessButton["default"], _extends({}, props, {
        disabled: disabled || state === _constants.LOADING,
        state: state
      }));
    }
  }]);

  return LoadingButton;
}(_react["default"].Component);

LoadingButton.propTypes = {
  disabled: _propTypes["default"].bool,
  // eslint-disable-line react/boolean-prop-naming
  hasSuccessDisabled: _propTypes["default"].bool,
  isLoading: _propTypes["default"].bool.isRequired,
  successTimeout: _propTypes["default"].number
};
LoadingButton.defaultProps = {
  disabled: false,
  hasSuccessDisabled: true,
  successTimeout: 3000
};
var _default = LoadingButton;
exports["default"] = _default;